import { render, staticRenderFns } from "./user-listjg-staff.vue?vue&type=template&id=c70b636e&scoped=true&"
import script from "./user-listjg-staff.vue?vue&type=script&lang=js&"
export * from "./user-listjg-staff.vue?vue&type=script&lang=js&"
import style0 from "./user-listjg-staff.vue?vue&type=style&index=0&id=c70b636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b636e",
  null
  
)

export default component.exports